import React, { forwardRef } from 'react';
import Chart from 'chart.js/auto';
import { Chart as ReactChart } from 'react-chartjs-2';

const CustomChart = forwardRef(({ type, data, plugins, options, ...chartOptions }, ref) => {
  return <ReactChart type={type} plugins={plugins} data={data} options={options} ref={ref} {...chartOptions} />;
});

export default CustomChart;
